module.exports = __webpack_public_path__ + "static/media/Yay.0ba5d854.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/Yay.mp3
// module id = 119
// module chunks = 0